<template>
  <div class="dropdown-container">
    <a href="#" v-on:click.prevent="showDropDown=!showDropDown" v-on-clickaway="away">
      <div class="dropdown-title">{{selectedView.title}}</div>
    </a>
    <transition name="dropdown-list">
      <div v-show="showDropDown" class="drowpdown-list">
        <ul>
          <li v-for="(viewType, index) in viewTypes" v-bind:key="index">
            <!-- Had to use two different elements here because I only wanted to show
                 A tooltip if it's in a certain state. Will fix when I understand how to
                 build my own tooltip that's easier to manage than the vue-simple-tooltip 
            package-->
            <div
              v-show="isOptionNotAvailable(viewType)"
              v-tooltip:left="getTooltipMessage(viewType)"
              v-on:click="setSelectedViewType(index)"
              class="not-available"
              :class="{'border-bottom' : index != viewTypes.length - 1}"
            >
              {{viewType.title}}
              <img :src="getViewTypeIcon(viewType.type)">
            </div>
            <div
              v-show="!isOptionNotAvailable(viewType)"
              v-on:click="setSelectedViewType(index)"
              :class="{'border-bottom' : index != viewTypes.length - 1 }"
            >
              {{viewType.title}}
              <img :src="getViewTypeIcon(viewType.type)">
            </div>
          </li>
        </ul>
      </div>
    </transition>

    <div class="type-description">{{selectedView.description}}</div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import tooltip from "vue-simple-tooltip";
import { mixin as clickaway } from "vue-clickaway";

var singleViewTypes = ["login", "signup"];

export default {
  name: "Dropdown",
  mixins: [clickaway],
  directives: { tooltip },
  mounted() {
    console.log(
      `views: ${
        this.getSelectedArchitectureViews
      } `
    );
    this.viewTypes =
      this.getSelectedArchitectureViews
    this.selectedView = this.viewTypes[0];
    this.$emit("selection", this.selectedView);
  },
  computed: {
    ...mapState(["views", "addedViewType"]),
    ...mapGetters(["getSelectedArchitectureValue", "getSelectedArchitectureViews"])
  },
  watch: {
    addedViewType: function(value) {
      console.log("AddedViewType: ", value);
      if (value === "signup" || value === "login") {
        this.selectedView = this.viewTypes[0];
      }
    }
  },
  methods: {
    away() {
      this.showDropDown = false;
    },
    getViewTypeIcon(type) {
      return require(`../assets/images/view-icons/${type}-view.svg`);
    },
    setSelectedViewType(index) {
      // If view type is available then select it
      if (this.viewTypes[index].available !== false) {
        // If the selected view type is a one type per project and already added then
        // don't add it again.
        if (
          !this.alreadyContainsSingleView(this.viewTypes[index].suggestedName)
        ) {
          this.showDropDown = !this.showDropDown;
          this.selectedView = this.viewTypes[index];
          this.$emit("selection", this.selectedView);

          // this.selectedView = this.viewTypes[0];
        }
      }
    },
    alreadyContainsSingleView(viewType) {
      if (viewType === undefined || viewType === null) {
        return false;
      }

      viewType = viewType.toLowerCase();

      var viewShouldHaveOnlyOne = singleViewTypes.includes(viewType);
      var typeAlreadyInViews = this.viewTypeAlreadyInViews(viewType);

      // console.log(
      //   `viewType:${viewType} viewShouldHaveOnlyOne: ${viewShouldHaveOnlyOne}, typeAlreadyInViews: ${typeAlreadyInViews}`
      // );

      return viewShouldHaveOnlyOne && typeAlreadyInViews;
    },
    viewTypeAlreadyInViews(viewType) {
      return this.views.map(view => view.type).includes(viewType);
    },
    isOptionNotAvailable(viewType) {
      return (
        this.alreadyContainsSingleView(viewType.type) ||
        viewType.available === false
      );
    },
    getTooltipMessage(viewData) {
      if (this.alreadyContainsSingleView(viewData.type)) {
        return "<p style='width:160px;font-family: Open Sans;font-size: 10px;'>This template only allows one of these view types</p>";
      }

      return "<p style='width:160px;font-family: Open Sans;font-size: 10px;'>This option is not available yet.</p>";
    }
  },
  data() {
    return {
      selectedView: {},
      showDropDown: false,
      viewTypes: []
    };
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/styles.scss";

ul,
li {
  list-style: none;
  margin: 0;
  padding: 0;
}

.border-bottom {
  border-bottom: 2px solid $info-container-color;
}

.dropdown-container {
  position: relative;
}

.drowpdown-list {
  position: absolute;
}

.dropdown-list-enter-active {
  animation: coming 0.3s;
  opacity: 0;
}

.dropdown-list-leave-active {
  animation: going 0.3s;
}

@keyframes going {
  from {
    transform: translateY(0px);
    opacity: 1;
  }
  to {
    transform: translateY(-50px);
    opacity: 0;
  }
}

@keyframes coming {
  from {
    transform: translateY(-50px);
    opacity: 0;
  }
  to {
    transform: translateY(0px);
    opacity: 1;
  }
}

.type-description {
  width: $input-field-width;
  background-color: $light-grey-color;
  margin-top: 20px;
  box-sizing: border-box;
  padding: 20px;
  border-radius: 5px;
  text-align: center;
}

ul {
  margin-top: 20px;
  background-color: $light-grey-color;
  width: $input-field-width;
  border-radius: 5px;
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.4);
}

li div {
  position: relative;
  box-sizing: border-box;
  height: $input-field-height;
  width: $input-field-width;
  text-align: center;
  padding-top: 10px;
  cursor: pointer;
  transition: 0.3s;

  img {
    position: absolute;
    width: 18px;
    height: 30px;
    right: 10px;
  }
}

li div:hover {
  background-color: $very-light-grey-color;
}

.not-available {
  border-radius: 5px;
  color: $background-color;
  // background: #969696;
}

a {
  color: white;
  text-decoration: none;
}

.dropdown-title {
  box-sizing: border-box;
  padding-top: 10px;
  background-color: $light-grey-color;
  border-radius: 5px;
  height: $input-field-height;
  width: $input-field-width;
  text-align: center;
  transition: 0.3s;
}

.dropdown-title:hover {
  background-color: $very-light-grey-color;
}
</style>
